import Services from './base-services'

const service = new Services('baseCountry')

export default {
    getAll() {
        return service.get('getBookCountriesFiltered', { params: { showCountriesWithBooks: true } })
    },
}
